import { connect } from 'react-redux'
import { setModal } from '@hixme/modal'

import { BUNDLE_COMPARE } from 'modal-constants'

import { selectors } from '../modules/health-bundles'
import CompareNav from '../components/CompareNav/CompareNav'

const mapStateToProps = (state) => ({
  groupFavoriteCount: selectors.getCurrentGroupFavoriteCount(state),
})

const mapDispatchToProps = (dispatch) => ({
  compare: () => dispatch(setModal(BUNDLE_COMPARE)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompareNav)
